import { useTenantTheme } from '@service/tenant/TenantThemeContext';
import { FC, SVGProps } from 'react';
import styled from 'styled-components';

export type LogoProps = SVGProps<SVGSVGElement>;

export const Logo: FC<LogoProps> = ({ ...rest }) => {
  const { theme } = useTenantTheme();

  if (!theme) return null;

  const logoSvg = theme?.logo?.svg?.main;
  const paths = logoSvg?.paths;

  return (
    <LogoIcon>
      <svg
        style={{ display: 'block', ...rest.style }}
        width={logoSvg?.size?.width}
        height={logoSvg?.size?.height}
        viewBox={logoSvg?.viewBox}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        {paths.map((path: any, index: number) => (
          <path
            key={index}
            fillRule='evenodd'
            clipRule='evenodd'
            {...path}
            fill={'#ACACAC'}
          />
        ))}
      </svg>
    </LogoIcon>
  );
};

const LogoIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;
  width: auto;
`;
